import { FramedHeroBanner, type HeroBannerProps } from './HeroBanner';
import { womanPlankHeroImage } from './assets/womanPlankImage';

/** Everything `FramedHeroBanner` takes except the image itself, which this component supplies. */
export type OnboardingHeroBannerProps = Omit<
  HeroBannerProps,
  'imageSrc' | 'imageSrcSet' | 'imageAvifSrcSet'
>;

/**
 * The one hero photo the onboarding flow uses, on every screen that has one.
 *
 * Exists so the asset wiring and its crop sit in a single place instead of being repeated at each
 * call site, where the four copies had already drifted apart once. `imagePriority` defaults to true
 * because the banner is the LCP element on every screen that renders it.
 */
export function OnboardingHeroBanner({
  imagePriority = true,
  imageObjectPosition = 'center 25%',
  ...rest
}: OnboardingHeroBannerProps) {
  return (
    <FramedHeroBanner
      imageSrc={womanPlankHeroImage.src}
      imageSrcSet={womanPlankHeroImage.srcSet}
      imageAvifSrcSet={womanPlankHeroImage.avifSrcSet}
      imagePriority={imagePriority}
      imageObjectPosition={imageObjectPosition}
      {...rest}
    />
  );
}
